import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const FAQ_ITEMS = [
    {
        question: "Can I use these models commercially?",
        answer: "Yes! All paid plans grant you full commercial ownership of every asset you generate. You can use them in games, films, ads, or resell them."
    },
    {
        question: "What file formats are supported?",
        answer: "We currently export to standard .GLB format, which is widely supported by Blender, Unity, Unreal Engine, Godot, and web viewers."
    },
    {
        question: "How long does generation take?",
        answer: "Most assets are generated in under 60 seconds. Complex prompts might take slightly longer, but our infrastructure is optimized for speed."
    },
    {
        question: "What happens if I run out of credits?",
        answer: "You can easily top up your credits at any time, or upgrade to a higher tier plan for a better rate. Unused credits roll over as long as your subscription is active."
    },
    {
        question: "Can I cancel anytime?",
        answer: "Yes, there are no long-term contracts. You can cancel your subscription instantly from your dashboard. You keep full ownership of all assets generated prior to cancellation."
    },
    {
        question: "Do I own the intellectual property?",
        answer: "Absolutely. Unlike some other platforms, we transfer full IP rights to you upon generation. The asset is yours to do with as you please."
    },
    {
        question: "Can I edit the models in other software?",
        answer: "Yes, the .GLB files are standard 3D files. You can import them into Blender, Maya, 3ds Max, or any other 3D software to modify geometry, UVs, or textures."
    }
];

function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-b border-border/50 last:border-0">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full py-6 flex items-center justify-between text-left hover:text-purple-400 transition-colors group"
      >
        <span className="font-bold text-lg group-hover:text-purple-400 transition-colors">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180 text-purple-400' : 'text-muted-foreground'}`} />
      </button>
      <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100 pb-6' : 'grid-rows-[0fr] opacity-0'}`}>
        <div className="overflow-hidden">
            <p className="text-muted-foreground leading-relaxed">{answer}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
    return (
        <div className="max-w-3xl mx-auto px-6 py-24 border-t border-border/50">
            <h2 className="text-3xl font-black uppercase tracking-tighter mb-12 text-center">Frequently Asked Questions</h2>
            <div className="space-y-2">
                {FAQ_ITEMS.map((item, index) => (
                    <FAQItem key={index} question={item.question} answer={item.answer} />
                ))}
            </div>
        </div>
    );
}
